var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modalGraphGen","ok-only":"","title":"Graph Generator","size":"xl"},on:{"hidden":_vm.resetModal}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('app-echart-line',{attrs:{"option-data":_vm.option}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }